export default [
    {
        id: 'q1', // copybook: Frage 1
        showInVideo: "all",
        startAt: 20,
        showAt: 30,
        endAt: 34,
        perspective: null,
        rewindTo: 0,

        car: {
            type: "Slider",
            question: "Wie viel Seitenabstand muss die Pkw-Fahrerin zum Radfahrer innerorts mindestens einhalten?",
            answerOptions: [
                {
                    id: "a1",
                    text: "1m",
                    isCorrectAnswer: false
                },
                {
                    id: "a2",
                    text: "1,50m",
                    isCorrectAnswer: true
                },
                {
                    id: "a3",
                    text: "2m",
                    isCorrectAnswer: false
                },
                {
                    id: "a4",
                    text: "2,50m",
                    isCorrectAnswer: false
                },
            ]
        },
        bike: {
            type: "MultipleChoice",
            question: "Was ist hier falsch gelaufen?",
            answerOptions: [
                {
                    id: "a1",
                    text: "Der Radfahrer hat vergessen seinen Richtungswechsel durch ein Handzeichen anzuzeigen.",
                    isCorrectAnswer: true
                },
                {
                    id: "a2",
                    text: "Das Auto hat den Radfahrer zu eng überholt. Der Radfahrer hätte scharf bremsen müssen.",
                    isCorrectAnswer: false
                },
                {
                    id: "a3",
                    text: "Der Radfahrer hat nicht den Vorrang des Autos beachtet.",
                    isCorrectAnswer: false
                },
            ]
        }

    },

    // ---------------------------

    {
        id: 'q2', // copybook: Frage 3
        showInVideo: "all",
        startAt: 45,
        showAt: 48,
        endAt: 52,
        perspective: null,
        rewindTo: 33,

        car: {
            type: "MultipleChoice",
            question: "Der Radfahrer ist ohne Handzeichen abgebogen. Was hat er außerdem nicht beachtet?",
            answerOptions: [
                {
                    id: "a1",
                    text: "Er ist nicht vom Fahrrad abgestiegen, um es über den Zebrastreifen zu schieben.",
                    isCorrectAnswer: true
                },
                {
                    id: "a2",
                    text: "Er hat nicht den Vorrang des Pkws beachtet.",
                    isCorrectAnswer: false
                },
                {
                    id: "a3",
                    text: "Er ist zu schnell über den Zebrastreifen gefahren.",
                    isCorrectAnswer: false
                },
            ]
        },
        bike: { // same as above
            type: "MultipleChoice",
            question: "Der Radfahrer ist ohne Handzeichen abgebogen. Was hat er außerdem nicht beachtet?",
            answerOptions: [
                {
                    id: "a1",
                    text: "Er ist nicht vom Fahrrad abgestiegen, um es über den Zebrastreifen zu schieben.",
                    isCorrectAnswer: true
                },
                {
                    id: "a2",
                    text: "Er hat nicht den Vorrang des Pkws beachtet.",
                    isCorrectAnswer: false
                },
                {
                    id: "a3",
                    text: "Er ist zu schnell über den Zebrastreifen gefahren.",
                    isCorrectAnswer: false
                },
            ]
        }
    },

    // ---------------------------

    {
        id: 'q3', // copybook: Frage 5
        showInVideo: "all",
        startAt: 68,
        showAt: 72,
        endAt: 76,
        perspective: null,
        rewindTo: 53,

        car: {
            type: "MultipleChoice",
            question: "Was hat die Autofahrerin falsch gemacht?",
            answerOptions: [
                {
                    id: "a1",
                    text: "Sie hat vergessen, den Warnblinker einzuschalten.",
                    isCorrectAnswer: false
                },
                {
                    id: "a2",
                    text: "Sie darf maximal eine Minute halten.",
                    isCorrectAnswer: false
                },
                {
                    id: "a3",
                    text: "Sie darf mit dem Pkw nicht auf dem Radfahrstreifen halten.",
                    isCorrectAnswer: true
                },
            ]
        },
        bike: {
            type: "MultipleChoice",
            question: "Warum hat der Radfahrer falsch reagiert?",
            answerOptions: [
                {
                    id: "a1",
                    text: "Er hat sich nicht in den fließenden Straßenverkehr eingeordnet oder sein Rad auf dem Gehweg geschoben.",
                    isCorrectAnswer: true
                },
                {
                    id: "a2",
                    text: "Er müsste das Auto rechts auf der Straße überholen.",
                    isCorrectAnswer: false
                },
                {
                    id: "a3",
                    text: "Er hätte hinter dem haltenden Auto warten müssen, bis es weiterfährt.",
                    isCorrectAnswer: false
                },
            ]
        }
    },

    // ---------------------------

    {
        id: 'q4', // copybook: Frage 4 (Ablenkung)
        showInVideo: "all",
        startAt: 86,
        showAt: 93,
        endAt: 97,
        perspective: null,
        rewindTo: 77,

        car: {
            type: "Slider",
            question: "Welche Strafe droht mindestens bei Handynutzung am Steuer?",
            answerOptions: [
                {
                    id: "a1",
                    text: "75 Euro,<br />kein Punkt in Flensburg",
                    isCorrectAnswer: false
                },
                {
                    id: "a2",
                    text: "100 Euro,<br />kein Punkt in Flensburg",
                    isCorrectAnswer: false
                },
                {
                    id: "a3",
                    text: "100 Euro,<br />1 Punkt in Flensburg",
                    isCorrectAnswer: true
                },
                {
                    id: "a4",
                    text: "150 Euro,<br />2 Punkte in Flensburg",
                    isCorrectAnswer: false
                },
            ]
        },
        bike: {
            type: "Slider",
            question: "Welches Bußgeld droht dem Radfahrer, wenn er wegen Ablenkung durch zu laute Musik auf den Kopfhörern den Verkehr behindert?",
            answerOptions: [
                {
                    id: "a1",
                    text: "10 Euro",
                    isCorrectAnswer: true
                },
                {
                    id: "a2",
                    text: "15 Euro",
                    isCorrectAnswer: false
                },
                {
                    id: "a3",
                    text: "20 Euro",
                    isCorrectAnswer: false
                },
                {
                    id: "a4",
                    text: "20 Euro, 1 Punkt in Flensburg",
                    isCorrectAnswer: false
                },
            ]
        }
    },


    // ---------------------------

    {
        id: 'q5',  // copybook: Frage 2
        showInVideo: "all",
        startAt: 116,
        showAt: 116,
        endAt: 120,
        perspective: null,
        rewindTo: 98,

        car: {
            type: "MultipleChoice",
            question: "Was hat die Autofahrerin beim Abbiegen falsch gemacht?",
            answerOptions: [
                {
                    id: "a1",
                    text: "Sie hat nicht geblinkt.",
                    isCorrectAnswer: false
                },
                {
                    id: "a2",
                    text: "Sie hat den Vorrang des Radfahrers nicht beachtet.",
                    isCorrectAnswer: true
                },
                {
                    id: "a3",
                    text: "Sie ist zu schnell abgebogen.",
                    isCorrectAnswer: false
                },
            ]
        },
        bike: { // same as above
            type: "MultipleChoice",
            question: "Was hat die Autofahrerin beim Abbiegen falsch gemacht?",
            answerOptions: [
                {
                    id: "a1",
                    text: "Sie hat nicht geblinkt.",
                    isCorrectAnswer: false
                },
                {
                    id: "a2",
                    text: "Sie hat den Vorrang des Radfahrers nicht beachtet.",
                    isCorrectAnswer: true
                },
                {
                    id: "a3",
                    text: "Sie ist zu schnell abgebogen.",
                    isCorrectAnswer: false
                },
            ]
        }
    },

    // ---------------------------

    {
        id: 'q6', // copybook: Frage 6 (Dooring)
        showInVideo: "all",
        startAt: 140,
        showAt: 141,
        endAt: 145,
        perspective: null,
        rewindTo: 122,

        car: {
            type: "MultipleChoice",
            question: "Was hat die Autofahrerin vor dem Aussteigen vergessen?",
            answerOptions: [
                {
                    id: "a1",
                    text: "Sie hat den holländischen Griff samt Schulterblick nicht gemacht.",
                    isCorrectAnswer: true
                },
                {
                    id: "a2",
                    text: "Sie hat die Spiegel nicht eingeklappt.",
                    isCorrectAnswer: false
                },
                {
                    id: "a3",
                    text: "Sie hat den Sicherheitsgurt nicht gelöst.",
                    isCorrectAnswer: false
                },
            ]
        },
        bike: {
            type: "MultipleChoice",
            question: "Welche Vorsichtsmaßnahme hat der Radfahrer nicht beachtet?",
            answerOptions: [
                {
                    id: "a1",
                    text: "Er hat nicht ausreichend Abstand zu parkenden Autos gehalten.",
                    isCorrectAnswer: true
                },
                {
                    id: "a2",
                    text: "Er hätte nicht auf der Straße fahren dürfen.",
                    isCorrectAnswer: false
                },
                {
                    id: "a3",
                    text: "Er ist zu schnell gefahren.",
                    isCorrectAnswer: false
                },
            ]
        }
    },
];

